import type { Translate } from "app/filters/i18nFilter";

const MAX_VISIBLE_NAMES = 5;

function getTooltipTranslation(t: Translate, listsWithDomain: string[]) {
    if (listsWithDomain.length > MAX_VISIBLE_NAMES + 1) {
        const topLists = listsWithDomain.slice(0, MAX_VISIBLE_NAMES);
        const lastLists = listsWithDomain.slice(MAX_VISIBLE_NAMES);

        return t("si.pages.account_review.add_to_list_button.tooltip.savedInManyLists", {
            listNames: topLists.map((listName) => `"${listName}"`).join(", "),
            moreCount: lastLists.length,
        });
    }

    if (listsWithDomain.length > 1) {
        const topLists = listsWithDomain.slice(0, listsWithDomain.length - 1);
        const lastListName = `"${listsWithDomain[listsWithDomain.length - 1]}"`;

        return t("si.pages.account_review.add_to_list_button.tooltip.savedInCoupleLists", {
            listNames: topLists.map((listName) => `"${listName}"`).join(", "),
            lastListName,
        });
    }

    return t("si.pages.account_review.add_to_list_button.tooltip.savedInList", {
        listName: listsWithDomain[0],
    });
}

export default getTooltipTranslation;
